module.exports = function() {
  return new Worker(__webpack_public_path__ + "3872f29be3ad45bf6481.worker.js");
};